import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { NewReviewModalContentContainer } from '../NewReviewModalContent';
import { NewReviewModalFooterContainer } from '../NewReviewModalFooter';
import { getIsOpen, getNewReviewFormStep } from '../../selectors/newReview';
import { setNewReviewFormClose } from '../../actions/newReview';
import { getIsAgent } from '../../selectors/user';
import { RejectionForBuilder } from '../../components/RejectionForBuilder';
import { FormModalLayout } from '../../components/FormLayout';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';
import { ENewReviewModalStep } from '../../types/newReview';

export const NewReviewModalContainer: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const isOpened = useSelector(getIsOpen);
  const step = useSelector(getNewReviewFormStep);
  const isInfoLayout = step === ENewReviewModalStep.Error || step === ENewReviewModalStep.Success;
  const isAgent = useSelector(getIsAgent);
  const { newbuildingName } = useSelector(getNewbuildingInfo);

  const onClose = React.useCallback(() => {
    dispatch(setNewReviewFormClose());
  }, [dispatch]);

  if (isAgent) {
    return (
      <FormModalLayout
        testId="RejectionForBuilder"
        shortTitle="Новый отзыв"
        open={isOpened}
        onClose={onClose}
        type="info"
      >
        <RejectionForBuilder onClose={onClose} />
      </FormModalLayout>
    );
  }

  return (
    <FormModalLayout
      title={`Отзыв о ЖК «${newbuildingName}»`}
      shortTitle="Новый отзыв"
      subtitle="Он появится на странице ЖК"
      footer={<NewReviewModalFooterContainer />}
      onClose={onClose}
      type={isInfoLayout ? 'info' : 'form'}
      open={isOpened}
      testId="NewReview"
    >
      <NewReviewModalContentContainer step={step} onClose={onClose} />
    </FormModalLayout>
  );
};
